import { render, staticRenderFns } from "./Solicitacao.vue?vue&type=template&id=3c900df9"
import script from "./Solicitacao.vue?vue&type=script&lang=js"
export * from "./Solicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports